var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11,0A11.83,11.83,0,0,0,0,7.5a11.82,11.82,0,0,0,22,0A11.83,11.83,0,0,0,11,0Zm0,12.5a5,5,0,1,1,5-5A5,5,0,0,1,11,12.5Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,11,4.5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }